import {
  Injectable,
  Type
} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RendererRegistryService {

  private renderers =
    new Map<string, Type<any>>();

  register(
    key: string,
    component: Type<any>
  ) {
    this.renderers.set(key, component);
  }

  resolve(key: string): Type<any> | null {

    return this.renderers.get(key) || null;
  }
}